import { render, staticRenderFns } from "./SpotlightQA.vue?vue&type=template&id=1a61dc90&scoped=true"
import script from "./SpotlightQA.vue?vue&type=script&lang=js"
export * from "./SpotlightQA.vue?vue&type=script&lang=js"
import style0 from "./SpotlightQA.vue?vue&type=style&index=0&id=1a61dc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61dc90",
  null
  
)

export default component.exports